import React from 'react';
import { useQuery } from '@apollo/client';
import { Container, Typography, CircularProgress } from '@mui/material';
import { GET_OUTGOING_ORDERS } from '../../../graphql/queries';
import OrdersTable from './OrdersTable';
import UnauthorizedErrorPage from '../../ErrorPages/UnauthorizedErrorPage';

const MyOrders: React.FC = () => {
  const { loading, error, data } = useQuery(GET_OUTGOING_ORDERS, {
    variables: {
      dateRange: {
        start: '2024-01-01',
        end: '2024-12-31',
      },
    },
  });

  if (loading) return <CircularProgress />;
  if (error) {
    if (error.message.toLowerCase().includes("authorization")) {
      return <UnauthorizedErrorPage/>;
    }
    return <p>Error: {error.message}</p>;

  }
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Outgoing Orders
      </Typography>
      <OrdersTable orders={data.outgoingSales} />
    </Container>
  );
};

export default MyOrders;
